const snakeToCamel = (string) =>
  string.toLowerCase().replace(/([-_][a-z])/g, (group) =>
    group
      .toUpperCase()
      .replace('-', '')
      .replace('_', ''),
  )

export default {
  pingTimer: 5000,
  typingDelay: 1000,
  // Delay between each reconnection attempt
  reconnectionTimeout: 5000,
  // Time to wait for websocket to open
  webSocketTimeout: 3000,
  // (reconnectionTimeout + webSocketTimeout) * Attempts = Amount of time for reconnection
  maxReconnectAttempts: 15,
  maxReconnectError: 'Max number of reconnect attempted',
  stages: {
    INITIALISING: 'INITIALISING',
    PRE_CHAT: 'PRE_CHAT',
    WAIT: 'WAIT',
    AGENT_CHAT: 'AGENT_CHAT',
    BOT_CHAT: 'BOT_CHAT',
    POST_CHAT: 'POST_CHAT',
  },
  stagesToControl: {
    INITIALISING: 'Form',
    PRE_CHAT: 'Form',
    WAIT: 'WaitingRoom',
    AGENT_CHAT: 'Messenger',
    BOT_CHAT: 'Messenger',
    POST_CHAT: 'Form',
  },
  snakeToCamel,
}
